import {createAction} from '@ngrx/store';
// Person Want MIS
export const wantMISCode = createAction('[Wait for MIS Code] wantMISCode');
